import React, { useEffect, useState } from 'react';
import { ModalsKeys } from 'global';
import { useModal } from 'hooks/useModal';
import { ImageGallery } from 'components/shared/Image';
import { DialogHeader } from 'components/shared/Dialog/DialogHeader';
import { Button, Dialog, DialogActions, DialogContent } from '@mui/material';
import { ImageGalleryItem } from 'types';
import { convertFileToDataUrl } from 'utils/convertFileToDataUrl';

export const PreviewNewEquipmentImagesDialog = () => {
  const { isOpen, handleClose, data } = useModal(ModalsKeys.PreviewNewEquipmentImagesDialog);

  const [images, setImages] = useState<ImageGalleryItem[]>([]);
  const [isLoadingImages, setIsLoadingImages] = useState(false);

  useEffect(() => {
    let cancelled = false;

    const loadImages = async () => {
      try {
        setIsLoadingImages(true);
        const items = await Promise.all(
          data.files
            .filter((f: File) => f.type.startsWith('image/'))
            .map(async (f: File) => ({
              id: f.name,
              url: await convertFileToDataUrl(f),
            }))
        );
        if (!cancelled) setImages(items);
      } catch (err) {
        console.error('Failed to build previews', err);
        if (!cancelled) setImages([]);
      } finally {
        if (!cancelled) setIsLoadingImages(false);
      }
    };

    loadImages();

    return () => {
      cancelled = true;
    };
  }, [data?.files]);

  const handleConfirm = () => {
    data.onConfirm(data.files.filter(f => images.find(i => i.id === f.name)));
    handleClose();
  };

  const handleDelete = (fileName: string) => {
    setImages(images => images.filter(i => i.id !== fileName));
  };

  return (
    <Dialog fullWidth maxWidth="md" open={isOpen} onClose={handleClose}>
      <DialogHeader label="Equipment images" handleClose={handleClose} />
      <DialogContent dividers>
        {!isLoadingImages && <ImageGallery onDelete={handleDelete} images={images} />}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button onClick={handleConfirm} variant="contained">
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};
